import React, { useState, useEffect, useRef } from "react";
import { FaPaperPlane, FaArrowLeft, FaPhone, FaVideo } from "react-icons/fa";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { getStoredToken } from "../component/utils/getStoredToken";
import { io } from "socket.io-client";
import { imgurl } from "../baseurl";
import NavigateHome from "../component/utils/NavigateHome";
import PageCount from "../component/utils/PageCount";

const API_BASE = "https://chat.soulsathi.com";

const ChatWindow = () => {
  const token = getStoredToken();
  const { uid } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const user = location.state?.user;

  const [messages, setMessages] = useState([]);
  const [newMsg, setNewMsg] = useState("");
  const socketRef = useRef();
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    setTimeout(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 50);
  };

  const loadMessages = async () => {
    try {
      const res = await axios.post(`${API_BASE}/chat/history`, { token, uid });
      setMessages(res.data);
      scrollToBottom();

      await axios.post(`${API_BASE}/chat/read`, { token, uid });
    } catch (err) {
      console.error("Failed to load messages:", err);
    }
  };

  useEffect(() => {
    if (!token) return;

    socketRef.current = io(API_BASE);
    socketRef.current.emit("join", { token });

    socketRef.current.on("new_message", (msg) => {
      if (msg.sender_id === user.user_id) {
        setMessages((prev) => [...prev, msg]);
        scrollToBottom();
      }
    });

    return () => socketRef.current.disconnect();
  }, [user]);

  useEffect(() => {
    loadMessages();
  }, [uid]);

  const sendMessage = async () => {
    if (!newMsg.trim()) return;
    const text = newMsg;
    setNewMsg("");

    try {
      await axios.post(`${API_BASE}/chat/send`, { token, uid, message: text });
      loadMessages();
    } catch (err) {
      console.error("Failed to send:", err);
    }
  };

  const formatTime = (dateStr) =>
    new Date(dateStr).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  if (!user) return <div>User not found</div>;

  return (
    <div className="chat-window-mobile">
      <PageCount pageName = {"Mobile Chat Window"}/>
<NavigateHome/>
      {/* --- Chat Header --- */}
      <div className="chat-header-mobile sticky-top bg-theme d-flex align-items-center justify-content-between p-2 border-bottom">
        <div className="d-flex align-items-center">
          <FaArrowLeft
            className="me-2"
            size={20}
            onClick={() => navigate(-1)}
            style={{ cursor: "pointer" }}
          />
          
          <Link to={`/profile/view/${user.uid}`} className="text-decoration-none">
          <img
            src={imgurl + user.profile_photo}
            alt={user.display_id}
            className="rounded-circle me-2"
            style={{ width: 40, height: 40 }}
          />
          <span className="fw-bold text-white">{user.display_id}</span></Link>
        </div>

        <div className="d-flex align-items-center">
          {/* <FaPhone className="me-3" size={20} style={{ cursor: "pointer" }} />
          <FaVideo size={20} style={{ cursor: "pointer" }} /> */}
        </div>
      </div>

      {/* --- Chat Messages --- */}
      <div className="chat-body p-2">
        {messages.map((msg, i) => (
          <div
            key={i}
            className={`message ${
              msg.is_me ? "sent" : msg.sender_id === user.user_id ? "received" : "sent"
            } mb-1`}
          >
            <p>{msg.message}</p>
            <span className="text-muted" style={{ fontSize: "0.7rem" }}>
              {formatTime(msg.created_at)}
            </span>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      {/* --- Chat Input --- */}
      <div className="chat-input-box d-flex p-2 border-top">
        <input
          type="text"
          className="  me-0"
          placeholder="Type a message..."
          value={newMsg}
          onChange={(e) => setNewMsg(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
        />
        <button className="btn btn-primary" onClick={sendMessage}>
          <FaPaperPlane />
        </button>
      </div>
    </div>
  );
};

export default ChatWindow;
